import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import HTML5Backend from 'react-dnd-html5-backend';
import TouchBackend from 'react-dnd-touch-backend';
import { DragDropContext } from 'react-dnd';
import { SprintChooser } from 'src/layout/SprintChooser';
import { TaskFilter } from './TaskFilter';
import { TaskBoardColumn } from './TaskBoardColumn';
import { FloatingActionButton, FontIcon } from 'material-ui';
import TaskForm from './TaskForm';
import Main from 'src/layout/Main';
var styles = {
    container: {
        display: 'flex',
        flexDirection: 'row',
        margin: '0 .25rem'
    },
    fab: {
        position: 'absolute',
        bottom: '20px',
        right: '20px'
    }
};
var mobileDeviceDetected = function () {
    var ua = window.navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return true;
    }
    else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        return true;
    }
    return false;
};
var dndBackend = mobileDeviceDetected() ? TouchBackend : HTML5Backend;
var TaskBoard = /** @class */ (function (_super) {
    tslib_1.__extends(TaskBoard, _super);
    function TaskBoard(props) {
        var _this = _super.call(this, props) || this;
        _this.load = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.taskStore.loadTasks(this.props.userStore.userIdForLoading, this.props.preferencesStore.displayClosedCards.value)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleCreate = function (e) {
            e.preventDefault();
            _this.setState({ isDialogOpen: true });
        };
        _this.handleDialogClose = function () {
            _this.setState({ isDialogOpen: false });
        };
        _this.props.userStore.authorization.subscribe(function () { return _this.props.taskStore.initialize(); });
        _this.state = {
            isDialogOpen: false
        };
        return _this;
    }
    TaskBoard.prototype.componentWillMount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.props.taskStore.sprintChanged.subscribe(this.load);
                return [2 /*return*/];
            });
        });
    };
    TaskBoard.prototype.componentWillUnmount = function () {
        this.props.taskStore.sprintChanged.unsubscribe(this.load);
    };
    TaskBoard.prototype.render = function () {
        var _a = this.props, taskStore = _a.taskStore, preferencesStore = _a.preferencesStore;
        if (!taskStore.statuses) {
            return null;
        }
        var containerStyle = tslib_1.__assign({}, styles.container);
        if (preferencesStore.hasSmallScreen) {
            containerStyle.flexDirection = 'column';
        }
        var columns = taskStore.statuses.map(function (status) {
            return React.createElement(TaskBoardColumn, { key: status.id, taskStore: taskStore, preferencesStore: preferencesStore, status: status, tasks: taskStore.getTasksByStatus(status.id) });
        });
        return (React.createElement(Main, null,
            React.createElement(SprintChooser, null),
            React.createElement(TaskFilter, null),
            React.createElement("div", { style: containerStyle }, columns),
            React.createElement(TaskForm, { isOpen: this.state.isDialogOpen, closed: this.handleDialogClose }),
            !this.props.userStore.canCreateOtherTasks ? null : (React.createElement(FloatingActionButton, { style: styles.fab, title: "Ticket r\u00F6gz\u00EDt\u00E9se", onClick: this.handleCreate },
                React.createElement(FontIcon, { color: "white", className: "material-icons" }, "add")))));
    };
    TaskBoard = tslib_1.__decorate([
        DragDropContext(dndBackend),
        inject('userStore', 'taskStore', 'preferencesStore'),
        observer
    ], TaskBoard);
    return TaskBoard;
}(React.Component));
export { TaskBoard };



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskBoard.tsx
// module id = 610
// module chunks = 0